/** Stable unique id generator. Never derive ids from display names. */
export function newId(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  // Fallback for exotic environments without crypto.randomUUID (should not happen in
  // Chrome/Edge/Firefox or Node 22, but keeps pure-logic code from throwing).
  const rnd = () => Math.floor(Math.random() * 0x10000).toString(16).padStart(4, '0');
  return `${rnd()}${rnd()}-${rnd()}-4${rnd().slice(1)}-a${rnd().slice(1)}-${rnd()}${rnd()}${rnd()}`;
}
